// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"5704ee10","300":"64105cac","488":"56ef4b08","530":"a85fa18f"}[chunkId] + ".chunk.js";
};